import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/global-functions';
import { Solutions } from 'src/app/utils/solutions';
import { Router } from '@angular/router';


@Component({
    selector: 'app-dashboard-component',
    templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
    constructor(
        private router: Router
    ) { }
    ngOnInit(): void {
        this.Load();
    }

    Load() {
        var user = User.userInSession();
        var idSolution = user.IDSolucaoEntidade;

        if (idSolution == Solutions.Luggage) {
            this.router.navigate(['dashboardlug']);
        } else if (idSolution == Solutions.Office) {
            this.router.navigate(['dashboardoffice']);
        } else if (idSolution == Solutions.ToolManegament) {
            this.router.navigate(['dashboardTool']);
        } else if (idSolution == Solutions.IndustrialVending) {
            this.router.navigate(['dashboardIndustrialVending']);
        } else {
            this.router.navigate(['dashboardlug']);
        }
    }
}
